import { Box, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Link } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import { safeAssetTypeAsIcon } from 'modules/it_management/components/AssetsList/utils'

import type { EquipmentDisplayItem } from 'modules/job_catalog/lib/equipmentUtils'

export interface EquipmentTagProps {
  item: EquipmentDisplayItem
}

const EquipmentTag = ({ item }: EquipmentTagProps) => {
  const [tooltipOpen, toggleTooltip] = useToggle(false)
  const categoryIcon = safeAssetTypeAsIcon(item.typeName)

  const tag = (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s4"
      className="inline-flex w-fit max-w-full rounded-full border-[1px] border-solid border-f1-border-secondary py-0.5 pl-1 pr-2 text-base font-medium text-f1-foreground"
    >
      <F0Icon icon={categoryIcon} size="sm" className="text-f1-icon" />
      <Text.Normal size="200" className="truncate">
        {item.label}
      </Text.Normal>
      {item.isInherited && <F0Icon icon={Link} size="sm" className="text-f1-icon" />}
    </Box>
  )

  if (item.isInherited && item.inheritedFromName) {
    return (
      <Tooltip.Alt
        attachment="top center"
        targetAttachment="bottom center"
        open={tooltipOpen}
        toggle={toggleTooltip}
        label={i18n.t('job_catalog.nodes.it_management.inherited_from', {
          nodeName: item.inheritedFromName,
        })}
      >
        <Box
          onMouseEnter={toggleTooltip(true)}
          onMouseLeave={toggleTooltip(false)}
          style={{ display: 'inline-flex' }}
        >
          {tag}
        </Box>
      </Tooltip.Alt>
    )
  }

  return tag
}

export default EquipmentTag
